import { render, staticRenderFns } from "./UnorderedListBase.vue?vue&type=template&id=7c4b4d02&scoped=true&lang=pug&"
import script from "./UnorderedListBase.vue?vue&type=script&lang=ts&"
export * from "./UnorderedListBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4b4d02",
  null
  
)

export default component.exports